import m from "@babel/runtime/helpers/esm/objectSpread2";
import { sstyled as n, assignProps as p } from "@semcore/core";
import s from "react";
import { Box as a } from "@semcore/flex-box";
function l(o) {
  var e = arguments[0], r, t = a;
  return r = n(o.styles), /* @__PURE__ */ s.createElement(t, r.cn("SDropdownItem", m({}, p({}, e))));
}
export {
  l as DropdownItem
};
